import axios from "axios";

const api = axios.create({
  baseURL: "https://serve-batalha-dev.herokuapp.com", // http://localhost:3000
});

export default api;
